export const TRANSLATION = 'builder.dashboard.job_search_help.resume_distribution.widget'
